/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AgentHostPreviewHistory
 */
export interface AgentHostPreviewHistory {
  /**
   *
   * @type {string}
   * @memberof AgentHostPreviewHistory
   */
  convId: string;
  /**
   *
   * @type {string}
   * @memberof AgentHostPreviewHistory
   */
  branchRef: string;
  /**
   *
   * @type {string}
   * @memberof AgentHostPreviewHistory
   */
  sha: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof AgentHostPreviewHistory
   */
  startedAt: OffsetDateTime;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof AgentHostPreviewHistory
   */
  stoppedAt: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof AgentHostPreviewHistory
   */
  reason: string;
  /**
   *
   * @type {boolean}
   * @memberof AgentHostPreviewHistory
   */
  revivable: boolean;
}

/**
 * Check if a given object implements the AgentHostPreviewHistory interface.
 */
export function instanceOfAgentHostPreviewHistory(
  value: object,
): value is AgentHostPreviewHistory {
  if (!("convId" in value) || value["convId"] === undefined) return false;
  if (!("branchRef" in value) || value["branchRef"] === undefined) return false;
  if (!("sha" in value) || value["sha"] === undefined) return false;
  if (!("startedAt" in value) || value["startedAt"] === undefined) return false;
  if (!("stoppedAt" in value) || value["stoppedAt"] === undefined) return false;
  if (!("reason" in value) || value["reason"] === undefined) return false;
  if (!("revivable" in value) || value["revivable"] === undefined) return false;
  return true;
}

export function AgentHostPreviewHistoryFromJSON(
  json: any,
): AgentHostPreviewHistory {
  return AgentHostPreviewHistoryFromJSONTyped(json, false);
}

export function AgentHostPreviewHistoryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AgentHostPreviewHistory {
  if (json == null) {
    return json;
  }
  return {
    convId: json["convId"],
    branchRef: json["branchRef"],
    sha: json["sha"],
    startedAt: json["startedAt"],
    stoppedAt: json["stoppedAt"],
    reason: json["reason"],
    revivable: json["revivable"],
  };
}

export function AgentHostPreviewHistoryToJSON(
  json: any,
): AgentHostPreviewHistory {
  return AgentHostPreviewHistoryToJSONTyped(json, false);
}

export function AgentHostPreviewHistoryToJSONTyped(
  value?: AgentHostPreviewHistory | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    convId: value["convId"],
    branchRef: value["branchRef"],
    sha: value["sha"],
    startedAt: value["startedAt"],
    stoppedAt: value["stoppedAt"],
    reason: value["reason"],
    revivable: value["revivable"],
  };
}
